module.exports = __webpack_public_path__ + "img/159.d07fa738.jpg";